/**
 * 计划任务完成提示通知工具模块
 * 使用 localStorage 记录每日弹出状态
 */

const STORAGE_KEY_PREFIX = 'plan_notification_'

/**
 * 获取今天的日期字符串 (YYYY-MM-DD)
 */
export function getTodayDate() {
  const now = new Date()
  const y = now.getFullYear()
  const m = String(now.getMonth() + 1).padStart(2, '0')
  const d = String(now.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

/**
 * 检查某个组今天是否已经弹过提示
 * @param {string} groupName
 * @returns {boolean}
 */
export function hasNotifiedToday(groupName) {
  const key = STORAGE_KEY_PREFIX + groupName
  const record = localStorage.getItem(key)
  return record === getTodayDate()
}

/**
 * 标记某个组今天已经弹过提示
 * @param {string} groupName
 */
export function setNotifiedToday(groupName) {
  const key = STORAGE_KEY_PREFIX + groupName
  localStorage.setItem(key, getTodayDate())
}

/**
 * 重置某个组的弹出记录（用于修改计划任务后变为未达成状态时）
 * @param {string} groupName
 */
export function resetNotification(groupName) {
  const key = STORAGE_KEY_PREFIX + groupName
  localStorage.removeItem(key)
}

/**
 * 检查计划任务列表是否全部达成
 * @param {Array} planList - 计划任务状态列表，每项包含 count 和 currentCount
 * @returns {boolean}
 */
export function isAllPlansCompleted(planList) {
  if (!planList || planList.length === 0) return false
  return planList.every(item => {
    // 只有 count > 0 的才需要检查
    if (item.count <= 0) return false
    return (item.currentCount || 0) >= item.count
  })
}
